// @flow
import { compose, withState, lifecycle, withHandlers } from "recompose";
import withUserCountry from "./withUserCountry";
import getUserLocation from "../libs/getUserLocation";
import getUserUnlockFeatures from "../libs/getUserUnlockFeatures";
import getSettings from "../libs/getSettings";

const withGetTopNine = compose(
  withUserCountry,
  withState("loading", "setLoading", true),
  withState("loginEnabled", "setLoginEnabled", true),
  withState("showFacebookInfoModal", "updateShowFacebookInfoModal", false),
  withState("showFacebookAccountsModal", "updateShowFacebookAccountsModal", false),
  withState("facebookPages", "updateFacebookPages", []),
  withState("disableAnonymousLogin", "setDisableAnonymousLogin", false),
  withState("disableLoginState", "setDisableLoginState", { open: false }),
  withState("userInteracted", "setUserInteracted", false),
  lifecycle({
    componentDidMount() {
      Promise.all([getUserUnlockFeatures(), getSettings()]).then(([features, settings]) => {
        if (features) {
          const { loginEnabled } = features;
          if (this.props.userInteracted && !loginEnabled) {
            this.props.setDisableLoginState({ open: true });
          }
          this.props.setLoginEnabled(loginEnabled);
        }
        if (settings) {
          this.props.setDisableAnonymousLogin(settings.disableAnonymousLogin);
        }
        this.props.setLoading(false);
      });
    },
  }),
  withHandlers({
    navigateToAuthorizedStep: props => () => {},
    handleFocusName: props => event => {
      const { userInteracted, setUserInteracted, loginEnabled, country } = props;
      if (!userInteracted) setUserInteracted(true);
      if (!loginEnabled) {
        event.target.blur();
        props.setDisableLoginState({ open: true });
        if (window.gtag) {
          window.gtag("event", "show_download_app_modal", { country });
        }
      }
    },
  })
);

export default withGetTopNine;
